import { ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useT } from "@/lib/i18n";

/**
 * Yetkisiz erişim sayfası. RequireRole guard'ı tarafından, kullanıcı
 * rol-uyumsuz bir route'a girdiğinde gösterilir. Backend de aynı sayfayı
 * 403 cevaplarında implicit olarak kullanır (frontend tarafında 403 hatasını
 * yakalayan global handler).
 */
export function ForbiddenPage() {
  const t = useT("forbidden");
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="items-center text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 text-amber-600 dark:bg-amber-950/40">
            <ShieldAlert className="h-7 w-7" />
          </div>
          <CardTitle>{t("title")}</CardTitle>
          <CardDescription>{t("description")}</CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Button asChild>
            <Link to="/">{t("cta")}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
